import { ScrollingModule } from '@angular/cdk/scrolling';
import { APP_BASE_HREF } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { QuicklinkModule } from 'ngx-quicklink';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../environments/environment';

import {
  AdminGuard,
  AdminProhibitedGuard,
  appInitializer,
  AuthGuard,
  AuthService,
  CaseInterceptor,
  CaseService,
  EncodeHttpParamsInterceptor,
  ErrorInterceptor,
  HeaderInterceptor,
  LeadAdminGuard,
  LeadAdminProhibitedGuard,
  NoAuthGuard,
  OwnerEntityGuard,
  OwnerGuard,
  PmDemoInterceptor,
  SecondaryOwnerProhibitedGuard,
  SentryService
  //RetryInterceptor
  ,
  SharedService,
  TokenInterceptor
} from '@app/core';
import { SentryErrorHandler } from '@app/core/handlers/sentry-error.handler';
import {
  BlankLayoutComponent,
  DemoLayoutComponent,
  EmptyLayoutComponent,
  HomeLayoutComponent,
  LoginLayoutComponent
} from '@app/layout';
import { JoyrideModule } from 'ngx-joyride';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppGlobals } from './app.global';
import { PurchaseManagerModule } from './modules/purchase-manager/purchase-manager.module';
import { SentryTestComponent } from './sentry-test.component';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [
    AppComponent,
    SentryTestComponent,
    BlankLayoutComponent,
    LoginLayoutComponent,
    HomeLayoutComponent,
    EmptyLayoutComponent,
    DemoLayoutComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    QuicklinkModule,
    ScrollingModule,
    JoyrideModule.forRoot(),
    SharedModule,
    PurchaseManagerModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: true,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    {
      provide: APP_BASE_HREF,
      useValue: "/"
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
      deps: [AuthService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
      deps: [AuthService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CaseInterceptor,
      multi: true,
      deps: [CaseService]
    },
    AppGlobals,
    AuthGuard,
    NoAuthGuard,
    AdminGuard,
    OwnerGuard,
    OwnerEntityGuard,
    LeadAdminProhibitedGuard,
    SecondaryOwnerProhibitedGuard,
    AdminProhibitedGuard,
    LeadAdminGuard,
    SharedService,
    Title,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EncodeHttpParamsInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PmDemoInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: SentryErrorHandler
    },
    SentryService,
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: RetryInterceptor,
    //   multi: true
    // } 
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }